import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { apiGetStories } from '../service/api'
import { Story } from '../types'
import styles from './Stories.module.scss'
import { ymGoal } from '../service/ym'

const Stories: React.FC = () => {
  useEffect(() => {
    loadStories()
    document.title = 'Букер!'
  }, [])

  const loadStories = async () => {
    await apiGetStories().then((res) => {
      const stories = res.data
      setStories(stories)
    })
  }

  const [stories, setStories] = useState<Story[]>([])

  if (!stories.length) return null

  return (
    <div className={styles.stories}>
      <div className={styles.booksList}>
        {stories.map((story, index) => (
          <div className={styles.book} key={index}>
            <Link
              key={story.id}
              to={`/stories/${story.slug}`}
              className={styles.link}
              onClick={() => {
                ymGoal(96230416, 'openStory')
              }}
            >
              <img src={`/covers/${story.cover}`} alt="book-cover" className={styles.cover} />
            </Link>
            <div className={styles.title}>{story.title}</div>
            <div className={styles.genre}>{story.genres}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Stories
